import type { SelectColumnOption } from "@/v2/framework/column/types";
import { t } from "@/services/i18n";

const FEED_TYPE_IDS = [1, 2, 3, 4, 5, 7] as const;

/** Static feed type id → display name (metadata entities share the same feed type ids). */
export function buildFeedTypeNameById(): Record<string, string> {
  return {
    "1": t("feed_types.manual_odds"),
    "2": t("feed_types.uof"),
    "3": t("feed_types.betgenius"),
    "4": t("feed_types.odds_scheme"),
    "5": t("feed_types.manual_resolve"),
    "7": t("feed_types.oddin_gg"),
  };
}

export function buildFeedTypeSelectOptions(): SelectColumnOption[] {
  const labels = buildFeedTypeNameById();
  return FEED_TYPE_IDS.map((id) => ({
    value: id,
    label: labels[String(id)],
  }));
}

export function buildFeedMapStatusSelectOptions(): SelectColumnOption[] {
  return [
    { value: 0, label: t("common.status.deleted") },
    { value: 1, label: t("common.status.active") },
    { value: 2, label: t("common.status.inactive") },
  ];
}
